import { enableScroll, disableScroll, getCookies, setCookies } from './tech/tech.js';
import * as  formsOld from './forms.js';


export default class Modal {
	constructor(element, cookies, options = {}) {
		let defaultOptions = {
			isOpen: () => { },
			isClose: () => { },
		}
		this.element = element;
		this.cookies = cookies;
		this.options = Object.assign(defaultOptions, options);
		this.modal = document.querySelector('._modal');
		this.modalBtn = document.querySelectorAll('._modal-btn');
		this.isOpen = false;
		this.speed = false;
		this.previousActiveElement = false;
		this.focusElements = [
			'a[href]',
			'input',
			'button',
			'select',
			'textarea',
			'[tabindex]'
		];
		this.events();

	}

	events() {
		if (this.modalBtn && this.modal) {
			document.addEventListener('click', (e) => {
				const clickedElement = e.target.closest('[data-modal]');

				if (clickedElement) {
					let target = clickedElement.dataset.modal;
					this.modalContainer = document.querySelector('.' + target);
					this.open();
					return;
				}
				if (e.target.closest('._modal__close')) {
					this.close();
					return;
				}

				if (e.target.closest('._modal__body')) {
					return;
				} else if (e.target.closest('._modal')) {
					this.close();
					return;
				}
			});

			/*if (this.cookies) {
				if (!getCookies(this.cookies)) {
					this.modalContainer = document.querySelector('.' + this.element);
					this.open();
					return;
				}
			}*/

			window.addEventListener('keydown', (e) => {
				if (e.keyCode == 27) {
					if (this.isOpen) {
						this.close();
					}
				}

				if (e.keyCode == 9 && this.isOpen) {
					this.focusCatch(e);
					return;
				}

			});


		}

	}

	open() {
		this.previousActiveElement = document.activeElement;
		this.modal.style.setProperty('--transition-time', `${this.speed / 1000}s`);
		//if (this.isOpen === false) {
		this.modalContainer.classList.add('_open');
		//this.modal.classList.add('_open');


		/*this.modalContainer.innerHTML = `
	<div class="_modal__overlay">
	<div class="_modal__cont">
	<div class="_modal__header">
	<button class="_modal__close" aria-label="Close modal"></button>
	</div>
	<div class="_modal__body">${this.modalContainer.innerHTML}</div>
	</div>
	</div>`;
	}*/
		this.modalContainer.innerHTML = `
		<div class="_modal__cont">
		<div class="_modal__header">
		<button class="_modal__close pwm-icon-close" aria-label="Close modal"></button>
		</div>
		<div class="_modal__body">${this.modalContainer.innerHTML}</div>
		</div>`;
		//}
		disableScroll();

		setTimeout(() => {
			this.options.isOpen(this);
			this.isOpen = true;
			this.focusTrap();

			formsOld.form();

		}, this.speed);

		this.element = '';
	}

	close() {
		if (this.modalContainer) {
			let element = this.modalContainer.querySelector('._modal__body').innerHTML;
			if (element) {
				this.modalContainer.innerHTML = element;
			}
			this.modalContainer.classList.remove('_open');
			//let countOpens = document.querySelectorAll('._modal__block._open');
			//console.log(this.modalContainer)
			//if (!countOpens.length) {
			this.modal.classList.remove('_open');
			this.options.isClose(this);
			this.isOpen = false;
			enableScroll();
			//}
			this.options.isClose(this);
			this.focusTrap();


		}
	}

	focusTrap() {
		const focusable = this.modalContainer.querySelectorAll(this.focusElements);
		if (this.isOpen) {
			focusable[0].focus();
		} else {
			this.previousActiveElement.focus();
		}
	}

	focusCatch(e) {
		const focusable = this.modalContainer.querySelectorAll(this.focusElements);
		const focusArray = Array.prototype.slice.call(focusable);
		const focusedIndex = focusArray.indexOf(document.activeElement);

		if (e.shiftKey && focusedIndex === 0) {
			focusArray[focusArray.length - 1].focus();
			e.preventDefault();
		}

		if (!e.shiftKey && focusedIndex === focusArray.length - 1) {
			focusArray[0].focus();
			e.preventDefault();
		}
	}
}